
import { defineComponent } from "vue";
import gameApplication from "../../game/game-app";

const RIGHT_ALIGN = 'right';

interface Props {
  align: any;
}

export default defineComponent({
  name: 'PlayerStatus',

  props: {
    name: { type: String, required: true },
    score: { type: Number, required: false },
    ball: {type: String, required: true },
    playerId: { type: String, required: true },
    playTurn: { type: String, required: true },
    timeLeft: { type: String, required: true },
    playerIcon: { type: String, required: false },
    displayScore: { type: Boolean, required: false },
    enablePassback: { type: Boolean, required: false },
    gameKind: { type: String, required: false },
    align: { type: String, default: 'left' },
  },

  computed: {
    isRightAlign: ({ align }: Props) => align === RIGHT_ALIGN,
  },

  methods: {
    concedeGame(): void {
      if (this.playTurn != '' && this.playTurn != null && this.playTurn === this.playerId) {
        // Emit "concede game" event to the Vue.js front end.
        gameApplication.fireEvent('CONCEDE_GAME');
      }
    },

    passBack(enablePassback): void {
      if (enablePassback && this.thisplayTurn != '' && this.playTurn != null && this.playTurn === this.playerId) {
        gameApplication.sendPassBack();
      }
    },
  },
});
